import inputData from './inputData/website-design-feedback-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'website-design-feedback-form',
  title: 'Website Design Feedback Form',
  description: 'Gather clear, constructive input from clients to refine your design work and deliver a better final result.',
  image: '/images/templates/website-design-feedback-form.png',
  tags: ['get-feedback', 'marketing', 'product'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

